module.exports = __webpack_public_path__ + "static/media/fuliyulanbiao.dbf436c0.png";